export default __webpack_public_path__ + "static/media/procurementValue1.94d04092.png";